import React from 'react'
import { compose } from 'recompose'
import styled from '@emotion/styled'
import withQueryParams from 'components/withQueryParams'
import withCurrentUser from 'components/withCurrentUser'
import withSession from 'components/withSession'
import { findPlatform } from 'config/platforms'
import { Loader } from 'stylist'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const RouteRedirecting = ({ query, currentUser, ...props }) => {
  const platform = findPlatform(
    query.get('platformId') || query.get('client_id')
  )
  const hostname = query.get('hostname')
  if (
    hostname &&
    currentUser &&
    currentUser.isHostnameFoundInUserServers(hostname) &&
    platform &&
    platform.loginUrl
  ) {
    window.location.href = platform.loginUrlFn(hostname)
  }

  return (
    <Container>
      <h5>You are being redirected {platform && `to ${platform.title}`}</h5>
      <Loader />
    </Container>
  )
}

export default compose(
  withQueryParams,
  withSession,
  withCurrentUser
)(RouteRedirecting)



// WEBPACK FOOTER //
// ./src/routes/login/redirecting.js